export default "__VITE_ASSET__0YpuBb8r__"